exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nheader {\n    height: 75px;\n    max-height: 75px;\n}\n.v-toolbar__content {\n@media screen and (max-width: 960px) {\n        justify-content: center;\n}\n}\n.toolbar--fixed {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100001;\n}\n\n/* Allow the quick access buttons to scroll if there are too many to fit, otherwise it overflows the rest of the page */\n.qa-button-container {\n    height: 56px;\n    overflow-y: scroll;\n}\n", ""]);

// exports
